import * as React from 'react'
import { About } from '~containers/About'

const KoreaPage = () => <About location="Asean" />

export default KoreaPage
